// src/pages/Products.js

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // 👉 install via: npm install framer-motion

const products = [
  {
    title: "Hostel & Library Management",
    desc: "Manage hostel bed bookings, approvals, and student records with ease. It includes real-time seat mapping, booking approval workflows, invoice generation, and student dashboards.",
    status: "ready",
    icon: "🛏️",
  },
  {
    title: "Clinic Management",
    desc: "Appointment scheduling, patient records, billing, and prescription management. Ideal for small to medium clinics.",
    status: "ready",
    icon: "🏥",
  },
  {
    title: "Ledger System",
    desc: "Track day-to-day income and expenses. Mimics a physical ledger with charts, summaries, and PDF bill generator.",
    status: "ready",
    icon: "📒",
  },
  {
    title: "Milk Dispenser",
    desc: "IoT-based smart milk vending system with quantity tracking and auto billing. Includes web dashboard to monitor usage and refill levels.",
    status: "inprocess",
    icon: "🥛",
  },
  {
    title: "The Rising Star",
    desc: "A digital platform to discover and promote local talents and creators. Includes profile pages, video uploads, voting system, and virtual events.",
    status: "inprocess",
    icon: "🌟",
  },
  {
    title: "Money Tracker",
    desc: "Manage your spends, credits, loans",
    status: "inprocess",
    icon: "📱",
  },
];

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openModal = (product) => setSelectedProduct(product);
  const closeModal = () => setSelectedProduct(null);

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-12">Our Products</h1>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((product, index) => (
          <div
            key={index}
            className="bg-accent shadow-md rounded-xl p-6 border border-secondary/10 hover:shadow-lg transition"
          >
            <div className="text-4xl mb-3">{product.icon}</div>
            <h2 className="text-xl font-semibold text-primary mb-2">{product.title}</h2>
            <p className="text-secondary mb-4 truncate">{product.desc.slice(0, 90)}...</p>
            <button
              onClick={() => openModal(product)}
              className="text-primary hover:underline"
            >
              Read More →
            </button>
          </div>
        ))}
      </div>

      {/* Modal with Animation */}
      <AnimatePresence>
        {selectedProduct && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-accent rounded-xl p-6 w-[90%] max-w-md max-h-[80vh] overflow-y-auto relative"
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              exit={{ y: 100 }}
              transition={{ duration: 0.3 }}
            >
              <button
                onClick={closeModal}
                className="absolute top-2 right-3 text-secondary/50 text-xl"
              >
                ✖
              </button>
              <div className="text-4xl mb-3">{selectedProduct.icon}</div>
              <h3 className="text-2xl font-bold text-primary mb-2">
                {selectedProduct.title}
              </h3>
              {selectedProduct.status === "inprocess" ? (
                <p className="text-secondary text-center py-4 font-medium text-lg">
                  🚧 This product is currently under development.
                  <br />
                  <span className="text-primary">Coming Soon!</span>
                </p>
              ) : (
                <p className="text-secondary">{selectedProduct.desc}</p>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Products;
